import React,{useRef, useState, useEffect} from "react";
import { Card, Row, Col, InputGroup, Form, Button} from "react-bootstrap";
import vindrApi from "../utils/vindrapi";

const bufferTimer = 200; //keyboard input tolerance timer before fetching content

class SearchProperty extends React.Component {

	
	constructor(props) {
		
		super(props);


		
		this.query = React.createRef();
		this.results = [];
		this.state = {
			loading:false
		};
		
		this.lastCall = null;
	}

	handleOnSearch(e){
		
		var self = this;
		if(this.lastCall)
			clearTimeout(this.lastCall);
		
		if(this.query.current.value.length < 3){
			return false;
		}
		this.lastCall = setTimeout(
			(msg) => {
				
				self.handleSearchPending(true);
				vindrApi.searchProperties(self.query.current.value).then((data)=>{
					self.results = self.processResults(data);
					self.handleSearchPending(false);
					self.lastCall = null;
				});
			},
			bufferTimer
		);
	};
	
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
	}
	handleOnPick(selected){
		this.query.current.value = selected.fullName;
		this.results = [];
		this.updateStatus({selected:selected});
		this.props.onPick(selected);
	}
	handleOnSelect(){
		this.props.onSelect(this.state.selected);
	}
	handleSearchPending(pending){
		
		this.updateStatus({loading:pending});
		if(this.props.onSearchPending)
			this.props.onSearchPending(pending);
		
	}
	processResults(res){
		
		//for now this is transparent, maybe in the future we need to update this
		return res.map((a)=>{
			return a;
		}); 
	}
	reset(){
		if(!this.props.keepResults){
			this.results = [];
			this.query.current.value='';
			this.updateStatus({loading:false, selected:null});
		}
	}
	searchHandler(){
		
		if(!this.results.length)
			return;
		
		if(this.props.searchHandler)
			this.props.searchHandler(this.results, this.query.current ? this.query.current.value : null);
		else{
			return (<>
				{!!this.results.length && 
				<Col xs="12" className="m-0 results">
				
					{this.results.map((a, k)=>{return <div key={k} className="result" onClick={(e)=>{this.handleOnPick(a);}}><div className="result-main">{a.id}</div><div className="result-desc">{a.status} {a.country}&nbsp;</div></div>})}
					
				</Col>
				}
				{this.state.loading && 
				<Col xs="12" className="m-0 results py-3">
					<span className="spinner-border spinner-border-sm text-info mx-auto"></span>
				</Col>
				}
				
			</>);
		}
	}


	render() {
		return (
			<Row className="searchProperty mb-3">
				<Col xs="12" className="m-0">
					<InputGroup className="mb-3">
						<InputGroup.Text id="basic-addon1"><i className="ri-search-line"></i></InputGroup.Text>
						<Form.Control type="text" name="query" ref={this.query} onChange={(e)=>{this.handleOnSearch(e)}} onClick={(e)=>{this.reset()}} autoFocus autoComplete="off" placeholder="Search for existing property" />
					</InputGroup>
								
					
				</Col>
				{this.searchHandler()}
			</Row>
		);
	}
}

export default SearchProperty;